import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';
import _ from 'lodash';

import PageHeader from '../../../shared/page-header/components/page-header';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import Button from '../../../shared/button/components/button';
import { togglePaymentMethodModal, handleSelectedPaymentMethodType, toggleAddPaymentMethodModal } from '../actions/payment-method-actions';
import constants from '../../../../common/constants';
import bankMethodImage from '../images/bank-method.png';

import '../styles/payment-method-modal.css';

class PaymentMethodModal extends Component {
  closeModal() {
    const { togglePaymentMethodModal } = this.props;

    togglePaymentMethodModal(false);
  }

  toggleAddBankAccountModal(paymentMethodTypeId) {
    this.closeModal();
    const { paymentMethodTypes } = this.props;

    const paymentMethodType = _.find(paymentMethodTypes, { payment_method_type_id: paymentMethodTypeId });

    if (paymentMethodType) {
      const { handleSelectedPaymentMethodType, toggleAddPaymentMethodModal } = this.props;

      handleSelectedPaymentMethodType(paymentMethodType);
      toggleAddPaymentMethodModal(true);
    }
  }

  render() {
    const { t } = this.context;
    const { showPaymentMethodModal } = this.props;

    return (
      <Modal visible={showPaymentMethodModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="default-modal payment-method-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="text-center">
            <PageHeader title={'PAYMENT_METHODS.ADD_METHOD_BTN'} />
          </div>
          <div className="payment-method-modal__wrapper">
            <img className="payment-method-modal__wrapper__img" src={bankMethodImage} alt="Bank Method" />
            <div className="payment-method-modal__wrapper__details">
              <p className="payment-method-modal__wrapper__details__title">{t('PAYMENT_METHODS.BANK_ACCOUNT')}</p>
              <p className="payment-method-modal__wrapper__details__text">{t('PAYMENT_METHODS.BANK_ACCOUNT_TEXT')}</p>
              <Button label={'PAYMENT_METHODS.LINK_BANK_ACCOUNT_BTN'} customClass={'affiliate-btn-red'} onClick={() => this.toggleAddBankAccountModal(constants.payment_method_types.bank.id)} />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showPaymentMethodModal: state.paymentMethodsReducer.showPaymentMethodModal,
  paymentMethodTypes: state.paymentMethodsReducer.paymentMethodTypes,
});

const mapDispatchToProps = dispatch => ({
  togglePaymentMethodModal: show => {
    dispatch(togglePaymentMethodModal(show));
  },
  handleSelectedPaymentMethodType: paymentMethod => {
    dispatch(handleSelectedPaymentMethodType(paymentMethod));
  },
  toggleAddPaymentMethodModal: show => {
    dispatch(toggleAddPaymentMethodModal(show));
  },
});

PaymentMethodModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodModal);



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/components/payment-method-modal.js